import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/recurring-invoices/$id/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/invoices/recurring-invoices/$id',
      params: { id: params.id },
      replace: true,
    })
  },
})
